(function () {
    'use strict';

    function QuickAccessToolsComponentController($scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader) {
        //
        var $ctrl = this;
        var pagingParams = {};
        $ctrl.loadPage = loadPage;
        $ctrl.findVersion = findVersion;


        loadAll();

        loadPage();


        function loadAll() {

            function onSuccess(data, headers) {

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {

            translatePartialLoader.addPart('global');
            translatePartialLoader = translate.refresh();

        }

        function findVersion() {

        }

        $scope.$watch('$ctrl.company', function () {
            findVersion();
        })

    }

    var QuickAccessToolsComponent = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/quick-access-tools/partial-form.quick-access-tools.html',
        controller: QuickAccessToolsComponentController,
        bindings:
            {
                company: '=',
            }

    };

    angular
        .module('tikonApp')
        .component('pfQuickAccessTools', QuickAccessToolsComponent)

    QuickAccessToolsComponentController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader'];


})();

